<template>
  <div class="ql-snow">
    <div
      class="content-box ql-editor"
      v-html="config.property_data.content || '请输入内容'"
      :style="
        'padding-top:' +
        config.property_data.margin_top +
        'px;padding-bottom:' +
        config.property_data.margin_bottom +
        'px;padding-left:' +
        config.property_data.margin_left +
        'px;padding-right:' +
        config.property_data.margin_right +
        'px;'
      "
    ></div>
  </div>
</template>

<script>
export default {
  name: "tms-text",
  props: ["config"],

  data() {
    return {};
  },
  computed: {
    conf() {
      return this.config.property_data.content;
    },
  },
  components: {},

  methods: {},
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>